import { Component } from '@angular/core';

@Component({
    selector: 'callList',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class CallListComponent {}
